import React from 'react';
import PrivacyContent from '../data/PrivacyContent';
import TermsContent from '../data/TermsContent';
import FAQContent from '../data/FAQContent';

const LegalModel = ({ section }) => {
  switch (section) {
    case 'privacy':
      return <PrivacyContent />;
    case 'terms':
      return <TermsContent />;
    case 'faq':
      return <FAQContent />;
    default:
      return (
        <div className="legal-content">
          <h2>Page Not Found</h2>
          <p>The requested legal section doesn’t exist.</p>
        </div>
      );
  }
};

export default LegalModel;
